import React from 'react';
import classnames from 'classnames';
import { RouteComponentProps } from 'react-router';
import get from 'lodash/get';
import Icon from 'components/Icon';
import { history } from 'helpers/router';
import { canOpenMailClient, openMailClient } from 'helpers/mail';
import { LOGIN, LANDING } from 'constants/routes';

import { Subtitle } from 'components/Text';
import { t } from 'components/Translate';

import OnboardingScreen from './Screen';
import styles from './Onboarding.module.scss';

class SignupSuccess extends React.Component<RouteComponentProps<{}, {}, { email?: string }>> {
  componentDidMount() {
    if (!this.email) {
      history.push(LANDING);
    }
  }

  private get email(): string | null {
    return get(this.props.location, 'state.email', null);
  }

  private onOpenMail = () => {
    if (!this.email) return;

    openMailClient(this.email);
    history.push(LOGIN);
  };
  render() {
    const email = this.email;
    const canOpen = email && canOpenMailClient(email);

    return (
      <div className={ styles.signupContainer }>
        <OnboardingScreen
          icon={ <Icon.Circled color="gray-shy" iconColor="black" name="mail" mark="success" size="x-large" /> }
          title={ t('onboarding.signup.success.title') }
          description={ t('onboarding.signup.success.description', { email }, true) }
          action={ canOpen ? t('common.action.openMail') : null }
          onClick={ this.onOpenMail }
          bottom={
            <Subtitle
              color="dark-light"
              type="small"
              className={ classnames(
                `${ styles.spam } t-center mt-0`,
                { 'mt-4': !canOpen },
              ) }
            >
              { t('onboarding.signup.success.warn') }
            </Subtitle>
          }
        />
      </div>
    );
  }
}

export default SignupSuccess;
